import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function MoneyReceiveSquareIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M12.573 9.049c-1.104 0-2 .671-2 1.5 0 .828.896 1.5 2 1.5 1.105 0 2 .671 2 1.5 0 .828-.895 1.5-2 1.5m0-6c.871 0 1.612.417 1.886 1m-1.886-1v-1m0 7c-.87 0-1.612-.418-1.886-1m1.886 1v1" />
      <path d="M13.571 2.549h-1c-4.478 0-6.717 0-8.108 1.391C3.07 5.331 3.07 7.57 3.07 12.05c0 4.478 0 6.717 1.392 8.109 1.39 1.39 3.63 1.39 8.108 1.39 4.479 0 6.718 0 8.11-1.39 1.39-1.392 1.39-3.63 1.39-8.11v-1" />
      <path d="m22.06 2.535-4.176 4.178m-.824-3.656.118 3.091c0 .729.435 1.183 1.228 1.24l3.124.147" />
    </SvgIcon>
  );
}
